import { render, staticRenderFns } from "./exchange-edit.vue?vue&type=template&id=6be8ed74&scoped=true&"
import script from "./exchange-edit.vue?vue&type=script&lang=js&"
export * from "./exchange-edit.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/i-switch.less?vue&type=style&index=0&id=6be8ed74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be8ed74",
  null
  
)

component.options.__file = "exchange-edit.vue"
export default component.exports